import React from 'react';


type Props = {
    className?  : string

    item        : any
    isSelected? : boolean

    onClick     : callback
}

export default function ItemViewLeftMenuItem(props:Props) {

    const onClick = () => {
        props.onClick(props.item.id)
    }

    const classes = Classes("item", props.className, {
        selected: props.isSelected
    })

    return (
        <div className  = {classes}
             onClick    = {onClick}
        >
            <div className="row">
                <div className={Classes("icon", props.item.icon)}/>
                <div className="name">{props.item.label}</div>
                {!_.isNil(props.item.counter) &&
                    <div className="counter">
                        {props.item.counter}
                    </div>
                }
            </div>
        </div>
    )
}
